const hostRegex = /^(?:https?:\/\/)?(?:[^@\n]+@)?(?:www\.)?([^\/\n?]+)/;

export const tryExtractHost = (url: string) : string => {
    const result = hostRegex.exec(url);
    return result && result.length >= 2 ? result[1] ?? url : url;
}